module.exports = {
	"next": "далее",
	"skip": "Перейти к созданию Cozy ",
	"cancel": "отмена",
	"back": "назад",
	"sign up": "регистрация",
	"add email": "добавить почтовый аккаунт",
	"welcome": "впусти меня!",
	"confirm": "подтвердить",
	"step preset": "настройки",
	"step import": "загрузка ваших данных",
	"step email settings": "настройка вашего email",
	"preset email": "e-mail",
	"preset email tip": "Он будет использован для связи с вами в случае утери вашего пароля.",
	"preset name": "имя",
	"preset name tip": "Она отображается, когда вы делитесь файлами с людьми или приглашаете их на мероприятия.",
	"preset password": "пароль",
	"preset password tip": "Необходим сложный пароль из более чем 8 символов( рекомендуются спец. символы).",
	"preset timezone": "Часовой пояс",
	"preset timezone tip": "Ваш часовой пояс необходим для корректного отображения дат событий в календаре.",
	"preset opt-in help": "Разрешить Cozy собирать мою статистику использования для улучшения продукта.",
	"preset opt-out newsletter": "Подписаться на рассылку Beta Cozy (крайне рекомендуется).",
	"import from google": "Загрузить данные из моего Google аккаунта.",
	"import google account": "Синхронизировать мой Gmail аккаунт и загрузить календарь, контакты и фотографии из Google.",
	"import google account tip": "Необходимо войти в аккаунт Google, чтобы Cozy имел доступ к данным, размещенным в сервисах Google",
	"leave google title": "Загрузка ваших данных в Cozy",
	"leave google help me": "Я не понимаю, что я хочу сделать, пожалуйста помогите мне!",
	"leave google sign in content": "Войдите в вашу учетную запись Google и предоставьте Cozy доступ к нему. Вы получите строку символов. Скопируйте ее в буфер обмена.",
	"leave google sign in": "Войти в учетную запись Google",
	"leave google code content": "Затем, скопируйте и вставьте код из всплывающей области:",
	"leave google code": "код google",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "Выберите, что сделать с данными размешенными в сервисах Google:",
	"leave google choice sync gmail": "GMail - Доступ к вашей почте из Cozy",
	"leave google choice contacts": "Разовая загрузка из Контактов Google",
	"leave google choice calendar": "Разовая загрузка из Календаря Google",
	"leave google choice photos": "Разовая загрузка из Фото Google",
	"leave google confirm": "Загрузка данных",
	"import error": "Возникает ошибка при попытке загрузить ваши данные. Пожалуйста, повторите попытку позже из специального приложения.",
	"login welcome": "Привет %{username}",
	"login enter your password": "Пожалуйста введите ваш пароль для доступа к вашему Cozy",
	"login password": "пароль",
	"login otp": "Код аутентификации",
	"login submit": "войти",
	"login auth success": "Успешная авторизация, заходим!",
	"login recover": "Забыли пароль? Отправить письмо с инструкциями",
	"login recover again": "Письмо не пришло? Повторить отправку",
	"login recover sent title": "Письмо отправлено",
	"login recover sent message": "Пожалуйста проверьте вашу почту, следуйте инструкциям в письме для сброса вашего пароля",
	"login recover error title": "Ошибка отправки письма",
	"login recover error message": "Ошибка отправки сообщения восстановления пароля, пожалуйста, проверьте работу вашего MTA или свяжитесь с администратором сервера",
	"login wrong password title": "Неправильные учетные данные",
	"login wrong password message": "Учетные данные введены неверно, попробуйте еще раз",
	"reset welcome": "Сброс пароля",
	"reset enter your password": "%{username}, пожалуйста, введите новый пароль, чтобы восстановить свой доступ",
	"reset password": "пароль",
	"reset submit": "сброс вашего пароля",
	"reset auth success": "пароль успешно сброшен",
	"reset wrong password title": "Ваш пароль не может быть сброшен",
	"reset wrong password message": "Введенный пароль некорректен или ваш код сброса устарел",
	"setup title": "Мы настраиваем ваш Cozy…",
	"setup message": "Вы близки к тому, чтобы иметь личное облако, где хранятся ваши данные.",
	"setup on mobile title": "Синхронизируйте ваши данные с вашим Android устройством!",
	"setup on mobile message": "Посмотрите наше приложение в Google Play:",
	"welcome title": "Поздравляю, что вернули контроль над своими личными данными!",
	"welcome message": "Теперь вы можете хранить свои данные на вашем личном облаке. В отличие от большинства облачных сервисов, оно не собирает данные о том, что вы в нем храните."
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/locales/ru.json
 ** module id = 36
 ** module chunks = 1
 **/